import { GridSpaceDataType } from 'data/types';

export function collisionSpacesForUserMove(
  spaces: GridSpaceDataType[],
  draggedIds: ReadonlySet<string>,
  leftoverIds: ReadonlySet<string>
): GridSpaceDataType[] {
  const isDraggingLeftover = [...draggedIds].some((id) => leftoverIds.has(id));
  return spaces.filter((space) => {
    if (draggedIds.has(space.spaceId)) {
      return false;
    }
    if (!isDraggingLeftover && leftoverIds.has(space.spaceId)) {
      return false;
    }
    return true;
  });
}

export function gridSpacesExcludingLeftovers(
  spaces: GridSpaceDataType[],
  leftoverIds: ReadonlySet<string>
): GridSpaceDataType[] {
  return spaces.filter((space) => !leftoverIds.has(space.spaceId));
}
